import { render } from "./z-unable-to-edit-office-task-modal.vue?vue&type=template&id=be432f8a"
import script from "./z-unable-to-edit-office-task-modal.vue?vue&type=script&lang=js"
export * from "./z-unable-to-edit-office-task-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__